import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-black text-white relative overflow-hidden">
      {/* grain overlay */}
      <div className="pointer-events-none fixed inset-0 z-0 opacity-[0.06] mix-blend-screen bg-noise" />

      {/* wordmark */}
      <header className="px-5 pt-6 pb-4 flex items-center justify-between relative z-10">
        <div className="font-mono text-sm tracking-[0.2em] uppercase">
          <span className="text-acid">/</span> the lobby
        </div>
        <div className="font-mono text-[10px] tracking-widest uppercase text-white/40">
          alpha · invite only
        </div>
      </header>

      {/* hero */}
      <section className="px-5 pt-10 pb-12 relative z-10">
        <h1 className="font-display leading-[0.85] tracking-tight">
          <span className="block text-5xl sm:text-6xl text-white">you go to shows.</span>
          <span className="block text-5xl sm:text-6xl text-white italic">you forget half of them.</span>
          <span className="block text-5xl sm:text-6xl text-acid mt-2">here's a place to put them.</span>
        </h1>

        <p className="mt-8 font-mono text-sm text-white/70 max-w-md leading-relaxed">
          a social diary for live performance in toronto.<br />
          save what you want to see.<br />
          log what you saw.<br />
          follow people whose taste you trust.
        </p>

        <Link
          to="/signup"
          data-testid="cta-signup"
          className="mt-10 inline-flex items-center gap-3 bg-acid text-black font-mono text-sm uppercase tracking-wider px-5 py-4 border-2 border-acid hover:bg-black hover:text-acid transition-colors"
        >
          sign up with invite code
          <ArrowRight className="w-4 h-4" strokeWidth={2.5} />
        </Link>

        <Link
          to="/login"
          data-testid="cta-login"
          className="mt-3 ml-2 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-white/60 hover:text-white"
        >
          already in? log in →
        </Link>
      </section>

      {/* what it does */}
      <section className="border-t-2 border-white/20 mt-4 relative z-10 px-5 py-8">
        <h2 className="font-mono text-xs uppercase tracking-[0.25em] text-white/50 mb-4">
          what it does
        </h2>
        <ul className="space-y-3 font-mono text-sm text-white/70 leading-relaxed">
          <li>· find what's on.</li>
          <li>· save what you might see.</li>
          <li>· log what you saw.</li>
          <li>· add stars, notes, and spoilers.</li>
          <li>· follow friends, artists, critics, strangers.</li>
          <li>· remember what closed.</li>
        </ul>
      </section>

      <footer className="px-5 py-10 relative z-10 font-mono text-[10px] text-white/30 tracking-widest">
        <div>made in toronto</div>
        <div className="mt-1">for people who talk about the show in the lobby.</div>
      </footer>
    </main>
  );
}
